module.exports = __webpack_public_path__ + "static/media/man.ccde6bd4.png";